import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import type { ReactNode } from 'react';

const Container = styled.div`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
  padding: ${tokens.spacer.x2} ${tokens.spacer.x2} 0 ${tokens.spacer.x2};
`;

interface GenericFilterHeaderProps {
  children?: ReactNode;
}

export function GenericFilterHeader({ children }: GenericFilterHeaderProps): JSX.Element {
  return <Container>{children}</Container>;
}
